<script lang="ts">
  import { onMount } from 'svelte';
  import { throttle } from '../../helpers';
  
  import ButtonBack from '../custom/ButtonBack.svelte'
  import HeaderBack from '../custom/HeaderBack.svelte'
  import MainNavigation from '../MainNavigation.svelte'
	import Header from './Header.svelte'
  import LowerHeader from './LowerHeader.svelte'
    import { location } from 'svelte-spa-router';

  export let isShowBackButton: boolean = false
  export let fixBottomPanel: boolean = false
  export let isEditor: boolean = false

  let opacity: number = 1
  let lastScrollTop = 0

  const isMobile: boolean = screen.width <= 576

  const scrollHandler = () => {
    let st = window.pageYOffset || document.documentElement.scrollTop

    opacity = st > lastScrollTop ? 0 : 1
    lastScrollTop = st <= 0 ? 0 : st
  }

  const throttleScrollHandler = throttle(scrollHandler, 300)

  const isMobileApp: boolean = JSON.parse(localStorage.getItem('from_mobile')) === true

  onMount(() => {
    if (!isShowBackButton || !isMobile) {
      return
    }

    window.addEventListener('scroll', throttleScrollHandler)

    return () => window.removeEventListener('scroll', throttleScrollHandler)
  });
</script>

<div class="general-layout">
  <div class="header-wrapper">
    {#if !isMobileApp && !$location.includes('publicate') && !$location.includes('topic') || !isMobile}
      <Header />
    {/if}
  
    {#if isShowBackButton}
      <HeaderBack />
    {/if}
  </div>
  
  <main 
    class:is-mobile-app={isMobileApp && !$location.includes('publicate')}
    style:grid-template-columns={isEditor ? '1fr' : '195px 1fr'}
  >
    {#if !isEditor}
      {#if isShowBackButton}
        <ButtonBack />
      {:else}
        <MainNavigation />
      {/if}
    {/if}

    {#if isEditor}
      <div class="editor-form">
        <slot />
      </div>
    {:else}
      <div 
        class="content"
        style:max-width={isShowBackButton ? '734px' : 'auto'}
        style:padding-bottom={fixBottomPanel ? '140px' : '90px'}
      >
        <slot />
      </div>
    {/if}

    {#if !isMobileApp}
      <LowerHeader />
    {/if}
  </main>
</div>

<style lang="scss">
  .editor-form {
    position: relative;
  }
  
  .header-wrapper {
    transition: opacity .3s;
    z-index: 9999;
    position: relative;
  }

  .general-layout {
    height: 100%;

    main {
      display: grid;
      padding: 114px 114px 0 80px;
      max-width: 1440px;
      margin: 0 auto;

      @media (min-width: 1000px) and (max-width: 1200px) {
        padding-left: 30px;
      }

      @media (min-width: 320px) and (max-width: 1000px) {
        display: flex;
        flex-direction: column;
        padding-left: 0;
        padding-right: 0;
        padding-top: 40px;
      }

      &.is-mobile-app {
        @media (min-width: 320px) and (max-width: 1000px) {
          padding-top: 0;
        }
      }

      .content {
        padding-left: 135px;
        padding-right: 110px;
        padding-bottom: 90px;
        overflow-x: hidden;

        @media (min-width: 1000px) and (max-width: 1200px) {
          padding-left: 60px;
        }

        @media (min-width: 320px) and (max-width: 1000px) {
          padding: 0 24px;
          padding-bottom: 60px;
          display: flex;
          flex-direction: column;
        }
      }
    }
  }
</style>